
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        description: { type: String, default: ''},
        unit: { type: String, default: ''},
        value: { type: Number, required: true},
        mask: { type: String, required: false, default: require('@/leaf_mask.png').default},
        aqi: { type: Number, required: false, default: -1}
    },

    computed: {

        aqiLvl(): number {
            return Math.floor(this.aqi/25);
        },

        aqiLvlLabel(): string {
            const level = this.aqiLvl;
            switch(level) {
                case 0:
                    return this.$t('dashboard.aqi.very_good');
                case 1:
                    return this.$t('dashboard.aqi.good');
                case 2:
                    return this.$t('dashboard.aqi.moderate');
                case 3:
                    return this.$t('dashboard.aqi.unhealthy');;
                case 4:
                    return this.$t('dashboard.aqi.very_unhealthy');
                default:
                    return '';
            }
        },

        airQualityBackgroundClass(): string {

            const level = this.aqiLvl;

            switch(level) {
                case 0:
                    return 'bg-aq-very-good';
                case 1:
                    return 'bg-aq-good';
                case 2:
                    return 'bg-aq-moderate';
                case 3:
                    return 'bg-aq-unhealty';
                case 4:
                    return 'bg-aq-very-unhealty';
                default:
                    return 'bg-aq-default';
            }
        },
    }
})

